<template>
    <div 
    class="leaflet-tooltip" 
    :class="{'leaflet-tooltip-left': left, 'leaflet-tooltip-right': right}" 
    :style="style">
        {{ this.label }}
    </div>
</template>

<script>
export default {
    name: 'ToolTip',
    props: {
        label: {
            type: String,
            default: 'ToolTip label'
        },
        x: {
            type: Number,
            default: 0
        },
        y: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            mapWidth: document.querySelector('.vue2leaflet-map').offsetWidth
        }
    },
    computed: {
        style() {
            return 'left:' + this.x + 'px;top:' + this.y + 'px';
        },
        left() {
            return this.x > (this.mapWidth / 2);
        },
        right() {
            return this.x <= (this.mapWidth / 2);
        }
    },
    created() {
        
    },
    methods: {

    }
}

</script>

<style scoped>
.leaflet-tooltip {
    z-index: 999;
}
.leaflet-tooltip-left {
    transform: translateX(-100%) translateX(-16px) translateY(-50%);
}
.leaflet-tooltip-right {
    transform: translate(16px, -50%);
}
</style>
